import styled from '@emotion/styled';

export const Table = styled.table`
  border-spacing: 0 ${({ theme }) => theme.space.xs}px;
  th,
  td {
    padding-right: ${({ theme }) => theme.space.s}px;
  }
`;
